module.exports = __webpack_public_path__ + "img/animal_health-t-22652-004-474x317.7a5150d6.jpg";